import { Button, Card, CardContent } from '@bia-auction/ui';
import { t } from '@bia-auction/shared-i18n';
import { Link, useParams } from '@tanstack/react-router';
import { CheckCircle2, Clock, XCircle } from 'lucide-react';

/**
 * 3DS redirect landing page (M7). The payment callback redirects the browser here via
 * `${PUBLIC_BIDDER_HOST}/payments/{success,fail,pending}` after the bank completes 3DS.
 */
export function PaymentResultPage() {
  const { result } = useParams({ from: '/shell/payments/$result' });
  const kind = result === 'success' ? 'success' : result === 'pending' ? 'pending' : 'fail';

  // §6 tint panels (redesign-bidder.md §7): the outcome reads from the whole panel,
  // not just an icon color.
  const { Icon, panel, title, body } = {
    success: {
      Icon: CheckCircle2,
      panel: 'bg-success-tint text-success-tint-fg',
      title: t('bidder.payment.successTitle'),
      body: t('bidder.payment.successBody'),
    },
    fail: {
      Icon: XCircle,
      panel: 'bg-danger-tint text-danger-tint-fg',
      title: t('bidder.payment.failTitle'),
      body: t('bidder.payment.failBody'),
    },
    pending: {
      Icon: Clock,
      panel: 'bg-info-tint text-info-tint-fg',
      title: t('bidder.payment.pendingTitle'),
      body: t('bidder.payment.pendingBody'),
    },
  }[kind];

  return (
    <div className="flex items-center justify-center px-4 py-10">
      <Card className="w-full max-w-sm text-center">
        <CardContent className="space-y-4 py-8">
          <div className={`mx-auto flex flex-col items-center gap-2 rounded-lg px-6 py-5 ${panel}`}>
            <Icon aria-hidden className="h-12 w-12" />
            <h1 className="font-head text-h2 font-semibold">{title}</h1>
            <p className="text-sm">{body}</p>
          </div>
          <Button asChild className="h-11 w-full sm:h-9">
            <Link to="/">{t('bidder.payment.backHome')}</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
